import { render } from "./DocDownload.vue?vue&type=template&id=1ef86c3f&ts=true"
import script from "./DocDownload.vue?vue&type=script&lang=ts"
export * from "./DocDownload.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__